import React, { useContext } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { AppStateContext } from '../AppStateContext';

import { AiFillMessage, AiOutlineMessage } from 'react-icons/ai'

const translations = {
    tr: {
        player1: {
            name: 'Amélie Dufresne',
            message: 'Tedavi sırasında herhangi bir ağrı veya rahatsızlık yaşamadım ve diş hekimimin ellerinde tamamen güvende hissettim. Ayrıca, modern teknolojilerin kullanımı ve kliniğin hijyenik ortamı sayesinde tedavi süreci son derece konforlu oldu. Tüm harika ekibe teşekkür ederim.',
            location: 'Strasbourg, Fransa'
        },
        player2: {
            name: 'Sasha Göringr',
            message: 'Yıllardır dişçi korkum nedeniyle yıllardır dişçiye gitmekten korkuyordum. Ancak, Yeşim Alkan ekibi sayesinde tüm tedavi sürecim ağrısız ve çok konforlu geçti. Sadece yeni bir ülke keşfetmekle kalmadım, aynı zamanda yıllardır sahip olduğum korkuyu da Yeşim Alkan ekibi sayesinde yendim.',
            location: 'Stuttgart, Almanya'
        },
        player3: {
            name: "Gabriele D'Alessio",
            message: 'Ülkemde birçok diş hekimini ziyaret ettikten sonra, bir arkadaşımdan duyduğum üzere Türkiye\'deki diş tedavi paketlerini araştırmaya karar verdim. Türkiye\'deki diş tedavilerinin ülkemdekilere göre çok daha ekonomik olduğunu keşfettim. Tedavi süreci çok konforlu ve keyifliydi. Herkese tavsiye ederim!',
            location: 'Trieste, İtalya'
        },
        player4: {
            name: 'Răzvan Georgescu',
            message: 'Yıllarca eksik ve lekeli dişlere sahiptim ve gülüşümden hiç memnun değildim. Ancak, Türkiye\'ye gelip diş tedavisi yaptırmak benim için bir dönüm noktası oldu. Şimdi ülkeme dönüyorum, tatilimin tadını çıkarıyorum ve parlak dişlerimle. Teşekkür ederim, Yeşim Alkan!',
            location: 'Bükreş, Romanya'
        },
        player5: {
            name: 'Leni Eberhardt',
            message: "Çocukluğumdan beri dişlerimde düzensizlikler vardı ve dişsel kusurlar nedeniyle gülümsemekten utanırdım. Yeşim Alkan sayesinde Türkiye\'ye ortodontik tedavi için geldim. Başarılı ve konforlu bir tedavi sonrası artık yeni dişlerimle özgürce ve mutlu bir şekilde gülümsüyorum. Yeşim Alkan'a çok teşekkür ederim!",
            location: 'Münih, Almanya'
        },
        player6: {
            name: 'Radka Blagoeva',
            message: "Yaşlandıkça yıllar içinde diş sorunları ve eksik dişler yaşamaya başladım. İmplant tedavisi için Yeşim Alkan'i seçtim. Birkaç arkadaşımdan işlemin acı verici olabileceğini duymuştum, ancak Türkiye'ye gelip tedaviye başladıktan sonra hiçbir ağrı yaşamadım. Tüm süreç benim için inanılmaz derecede rahat geçti. Teşekkür ederim!",
            location: 'Sofya, Bulgaristan'
        },
        player7: {
            name: 'Carmen Alarcóne',
            message: "Son zamanlarda 'Hollywood gülümsemesi' hakkında birçok şey duydum ve ben de mükemmel bir gülümsemeye sahip olmak istedim. İşte bu yüzden Yeşim Alkan'i seçtim ve yüzüme mükemmel bir şekilde uyum sağlayan kusursuz bir gülümseme yarattılar. Tüm ekibe teşekkür ederim!",
            location: 'Malaga, İspanya'
        }
    },
    en: {
        player1: {
            name: 'Amélie Dufresne',
            message: 'During the treatment, I experienced no pain or discomfort, and I felt completely safe in the hands of my dentist. Additionally, thanks to the use of modern technologies and the hygienic environment of the clinic, the treatment process was incredibly comfortable. I thank the entire wonderful team.',
            location: 'Strasbourg, France'
        },
        player2: {
            name: 'Sasha Göringr',
            message: 'Due to my fear of dentists, I have been afraid to go to the dentist for years. However, thanks to the Yeşim Alkan team, my entire treatment process was painless and very comfortable. Not only did I discover a new country, but I also overcame my fear that I had for years, all thanks to the Yeşim Alkan team.',
            location: 'Stuttgart, Germany'
        },
        player3: {
            name: "Gabriele D'Alessio",
            message: 'After visiting numerous dentists in my country, I decided to research dental treatment packages in Turkey upon hearing about them from a friend. I discovered that the dental treatments in Turkey are much more economical than the ones in my country. The treatment process was very comfortable and enjoyable. I highly recommend it to everyone!',
            location: 'Trieste, Italy'
        },
        player4: {
            name: 'Răzvan Georgescu',
            message: 'For years, I had missing and stained teeth, and I was always dissatisfied with my smile. However, coming to Turkey and getting dental work done was a turning point for me. Now, I am returning to my country, enjoying my vacation, and with my sparkling teeth. Thank you, Yeşim Alkan!',
            location: 'Bucharest, Romania'
        },
        player5: {
            name: 'Leni Eberhardt',
            message: 'I had misalignments in my teeth since childhood, and I used to feel embarrassed to smile due to the dental imperfections. Thanks to Yeşim Alkan, I came to Turkey for orthodontic treatment. After a successful and comfortable treatment, I am now smiling freely and happily with my new teeth. Many thanks to Yeşim Alkan!',
            location: 'München, Germany'
        },
        player6: {
            name: 'Radka Blagoeva',
            message: "As I aged, I started experiencing dental issues and missing teeth over the years. I chose Yeşim Alkan for implant treatment. I had heard from a few friends that the process could be painful, but after coming to Turkey and starting the treatment, I didn't experience any pain at all. The entire process was incredibly comfortable for me. Thank you!",
            location: 'Sofia, Bulgaria'
        },
        player7: {
            name: 'Carmen Alarcóne',
            message: "I had been hearing a lot about the 'Hollywood smile' recently, and I also wanted to have a perfect smile. That's why I chose Yeşim Alkan, and they created a flawless smile that perfectly suits my face. Thank you to the entire team!",
            location: 'Malaga, Spain'
        }
    },
    it: {
        player1: {
            name: 'Amélie Dufresne',
            message: 'Durante il trattamento, non ho provato dolore o disagio e mi sono sentita completamente al sicuro tra le mani del mio dentista. Inoltre, grazie all\'uso delle moderne tecnologie e all\'ambiente igienico della clinica, il processo di trattamento è stato incredibilmente confortevole. Ringrazio tutto il meraviglioso team.',
            location: 'Strasburgo, Francia'
        },
        player2: {
            name: 'Sasha Göringr',
            message: 'A causa della mia paura dei dentisti, ho evitato di andare dal dentista per anni. Tuttavia, grazie al team di Yeşim Alkan, l\'intero processo di trattamento è stato indolore e molto confortevole. Non solo ho scoperto un nuovo paese, ma ho anche superato la paura che avevo da anni, tutto grazie al team di Yeşim Alkan.',
            location: 'Stoccarda, Germania'
        },
        player3: {
            name: "Gabriele D'Alessio",
            message: 'Dopo aver visitato numerosi dentisti nel mio paese, ho deciso di cercare pacchetti di trattamento dentale in Turchia dopo averne sentito parlare da un amico. Ho scoperto che i trattamenti dentali in Turchia sono molto più economici rispetto a quelli nel mio paese. Il processo di trattamento è stato molto confortevole e piacevole. Lo consiglio vivamente a tutti!',
            location: 'Trieste, Italia'
        },
        player4: {
            name: 'Răzvan Georgescu',
            message: 'Per anni ho avuto denti mancanti e macchiati e sono sempre stato insoddisfatto del mio sorriso. Tuttavia, venire in Turchia e fare un lavoro dentale è stato un punto di svolta per me. Ora, sto tornando nel mio paese, godendomi le vacanze e con i denti scintillanti. Grazie, Yeşim Alkan!',
            location: 'Bucarest, Romania'
        },
        player5: {
            name: 'Leni Eberhardt',
            message: 'Avevo problemi di allineamento nei denti fin dall\'infanzia e mi vergognavo di sorridere a causa delle imperfezioni dentali. Grazie a Yeşim Alkan, sono venuta in Turchia per un trattamento ortodontico. Dopo un trattamento di successo e confortevole, ora sorrido liberamente e felicemente con i miei nuovi denti. Mille grazie a Yeşim Alkan!',
            location: 'Monaco di Baviera, Germania'
        },
        player6: {
            name: 'Radka Blagoeva',
            message: "Invecchiando, ho iniziato a riscontrare problemi dentali e denti mancanti nel corso degli anni. Ho scelto Yeşim Alkan per il trattamento con gli impianti. Avevo sentito da alcuni amici che il processo poteva essere doloroso, ma dopo essere venuta in Turchia e aver iniziato il trattamento, non ho provato alcun dolore. L'intero processo è stato incredibilmente confortevole per me. Grazie!",
            location: 'Sofia, Bulgaria'
        },
        player7: {
            name: 'Carmen Alarcóne',
            message: "Ultimamente avevo sentito molto parlare del 'sorriso hollywoodiano' e volevo anch'io avere un sorriso perfetto. Ecco perché ho scelto Yeşim Alkan e hanno creato un sorriso impeccabile che si adatta perfettamente al mio volto. Grazie a tutto il team!",
            location: 'Malaga, Spagna'
        }
    },
};

const LogoSlider = () => {
    const { language } = useContext(AppStateContext);

    const getText = (key) => {
        return translations[language][key] || key; // Default to the provided key if translation is not found
    };

    const treatments = [
        {
            key: 'player1',
            name: getText('player1.name'),
            message: getText('player1.message'),
            location: getText('player1.location'),
        },
        {
            key: 'player2',
            name: getText('player2.name'),
            message: getText('player2.message'),
            location: getText('player2.location'),
        },
        {
            key: 'player3',
            name: getText('player3.name'),
            message: getText('player3.message'),
            location: getText('player3.location'),
        },
        {
            key: 'player4',
            name: getText('player4.name'),
            message: getText('player4.message'),
            location: getText('player4.location'),
        },
        {
            key: 'player5',
            name: getText('player5.name'),
            message: getText('player5.message'),
            location: getText('player5.location'),
        },
        {
            key: 'player6',
            name: getText('player6.name'),
            message: getText('player6.message'),
            location: getText('player6.location'),
        },
        {
            key: 'player7',
            name: getText('player7.name'),
            message: getText('player7.message'),
            location: getText('player7.location'),
        },

    ];

    const settings = {
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: null,
        prevArrow: null,
        responsive: [
            {
                breakpoint: 500, // Adjust the breakpoint as needed
                settings: {
                    slidesToShow: 1, // Number of slides to show on screens with width <= 1024px
                },
            },
        ],
    };

    return (
        <Slider {...settings}>
            {treatments.map((item, index) => (
                <div key={index} className='pt-10'>
                    <div className='md:px-2'>
                        <div className='flex flex-col w-full border-2 rounded-2xl border-slate-200 p-5 md:p-10'>
                            <div className='pb-2 md:text-lg'>{getText(item.key).message}</div>
                            <AiFillMessage size={25} className='text-[#0F969C]' />
                            <div className='text-xl md:text-2xl pt-5'>{getText(item.key).name}</div>
                            <div className='text-lg md:text-xl text-slate-400'>{getText(item.key).location}</div>
                        </div>
                    </div>

                </div>
            ))}
        </Slider>
    );
};

export default LogoSlider;
